import { records } from './records.mock';

export const songSearch = {
  filters: [
    {
      label: 'Genres',
      name: 'genres',
      values: ['Action Adventure']
    }
  ],
  page: {
    offset: 0,
    pageSize: 100,
    total: 10
  },
  songs: [records.songs[0]]
};
